/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_tip_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A 50 bill with a 20% tip = 10 tip, 60 total.`)
};

const es_pct_tip_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una cuenta de 50 con una propina del 20% = 10 de propina, 60 en total.`)
};

const de_pct_tip_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Rechnung über 50 mit 20 % Trinkgeld = 10 Trinkgeld, 60 gesamt.`)
};

const nl_pct_tip_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een rekening van 50 met 20% fooi = 10 fooi, 60 totaal.`)
};

const fr_pct_tip_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une addition de 50 avec un pourboire de 20 % = 10 de pourboire, 60 au total.`)
};

const it_pct_tip_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un conto di 50 con una mancia del 20% = 10 di mancia, 60 totale.`)
};

const pt_br2_pct_tip_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma conta de 50 com 20% de gorjeta = 10 de gorjeta, 60 no total.`)
};

const pt_pct_tip_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma conta de 50 com uma gorjeta de 20% = 10 de gorjeta, 60 no total.`)
};

const ja_pct_tip_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`50の会計に20%のチップ = チップ10、合計60。`)
};

const zh_pct_tip_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`50 的账单加 20% 小费 = 10 小费，总额 60。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_tip_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_tip_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_tip_ex1", locale)
	if (locale === "en") return en_pct_tip_ex1(inputs)
	if (locale === "es") return es_pct_tip_ex1(inputs)
	if (locale === "de") return de_pct_tip_ex1(inputs)
	if (locale === "nl") return nl_pct_tip_ex1(inputs)
	if (locale === "fr") return fr_pct_tip_ex1(inputs)
	if (locale === "it") return it_pct_tip_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_pct_tip_ex1(inputs)
	if (locale === "pt") return pt_pct_tip_ex1(inputs)
	if (locale === "ja") return ja_pct_tip_ex1(inputs)
	return zh_pct_tip_ex1(inputs)
};